import { client, urlFor, getSanityEditLink } from "./sanity-client";
import initScrollAnimations from "./animations";

document.addEventListener("DOMContentLoaded", async () => {
  const heroSection = document.getElementById("internships-hero-section");
// ... existing checks ...
  if (!document.querySelector('meta[name="keywords"][content*="Internship"]')) return;

  try {
    const query = `*[_type == "internships"][0]{
            ...,
            showHero,
            showWhyUs,
            showDomains,
            showProjects,
            whyUs[]{..., _key}
        }`;
    const data = await client.fetch(query);

    if (!data) {
      console.error("Internships data not found");
      return;
    }

    // 1. Hero Section
    if (data.showHero === false) {
      const heroTitleEl = document.getElementById("internships-hero-title");
      if (heroTitleEl) heroTitleEl.closest('section').style.display = 'none';
    } else {
      const heroTitleEl = document.getElementById("internships-hero-title");
      if (heroTitleEl) {
        if (data._id) {
          heroTitleEl.parentElement.classList.add('position-relative');
          heroTitleEl.insertAdjacentHTML('beforebegin', getSanityEditLink(data._id, 'internships', 'heroTitle', 'Edit Hero Title'));
        }
        const words = data.heroTitle.split(' ');
        const lastWord = words.pop();
        heroTitleEl.innerHTML = `${words.join(' ')} <br /> <span class="text-primary">${lastWord}</span>`;
      }

      const heroDescEl = document.getElementById("internships-hero-desc");
      if (heroDescEl) heroDescEl.textContent = data.heroDescription;

      const heroImageEl = document.getElementById("internships-hero-image");
      if (heroImageEl && data.heroImage) {
        heroImageEl.src = urlFor(data.heroImage).url();
      }
    }

    // 2. Why Us Section
    if (data.showWhyUs === false) {
      const whyUsContainer = document.getElementById("internships-why-us-list");
      if (whyUsContainer) whyUsContainer.closest('section').style.display = 'none';
    } else {
      const whyUsContainer = document.getElementById("internships-why-us-list");
      if (whyUsContainer && data.whyUs) {
        renderWhyUs(whyUsContainer, data.whyUs, data._id);
      }
    }

    // 3. Domains & Technologies
    if (data.showDomains === false) {
      const domainsContainer = document.getElementById("internships-domains-list");
      if (domainsContainer) domainsContainer.closest('section').style.display = 'none';
    } else {
      const domainsContainer = document.getElementById("internships-domains-list");
      if (domainsContainer && data.domains) {
        if (data._id) {
          domainsContainer.classList.add('position-relative');
          domainsContainer.insertAdjacentHTML('beforebegin', getSanityEditLink(data._id, 'internships', 'domains', 'Edit Domains'));
        }
        renderBadges(domainsContainer, data.domains);
      }

      const techContainer = document.getElementById("internships-tech-list");
      if (techContainer && data.technologies) {
        if (data._id) {
          techContainer.classList.add('position-relative', 'pb-4');
          techContainer.insertAdjacentHTML('beforebegin', getSanityEditLink(data._id, 'internships', 'technologies', 'Edit Technologies'));
        }
        renderBadges(techContainer, data.technologies);
      }

      const secondaryImageEl = document.getElementById("internships-secondary-image");
      if (secondaryImageEl && data.secondaryImage) {
        secondaryImageEl.src = urlFor(data.secondaryImage).url();
      }
    }

    // 4. Projects Section
    if (data.showProjects === false) {
      const projectsDescEl = document.getElementById("internships-projects-desc");
      if (projectsDescEl) projectsDescEl.closest('section').style.display = 'none';
    } else {
      const projectsDescEl = document.getElementById("internships-projects-desc");
      if (projectsDescEl) {
        if (data._id) {
          projectsDescEl.parentElement.classList.add('position-relative');
          projectsDescEl.insertAdjacentHTML('beforebegin', getSanityEditLink(data._id, 'internships', 'projects', 'Edit Projects Section'));
        }
        projectsDescEl.textContent = data.projects.description;
      }

      const projectsBtnEl = document.getElementById("internships-projects-btn");
      if (projectsBtnEl) {
        projectsBtnEl.textContent = data.projects.buttonText;
        projectsBtnEl.href = data.projects.buttonLink || '#';
      }

      const projectImagesContainer = document.getElementById("internships-project-images");
      if (projectImagesContainer && data.projects.images) {
        renderProjectImages(projectImagesContainer, data.projects.images);
      }
    }

    // Re-initialize animations after content injection
    initScrollAnimations();

  } catch (error) {
    console.error("Error fetching Internships data:", error);
  }
});

function renderWhyUs(container, items, docId) {
  let html = '';
  items.forEach((item, index) => {
    html += `
            <div class="col-12 col-md position-relative ${index === 0 ? 'px-md-0' : ''}" data-animate="fade-up" data-delay="${index * 100}">
              ${docId && item._key ? getSanityEditLink(docId, 'internships', `whyUs[_key=="${item._key}"]`, 'Edit Reason') : ''}
              <div class="ct-label mb-4">${item.title}</div>
              <p class="fs-lg text-muted mb-0 text-justify">
                ${item.description}
              </p>
            </div>
        `;
    if (index === 0 && items.length > 1) {
      html += `<div class="col-1"></div>`;
    }
  });

  container.innerHTML = `<div class="row">${html}</div>`;
}

function renderBadges(container, items) {
  const html = items.map((item, index) => `
        <span class="badge rounded-pill bg-primary-soft text-primary px-4 py-2 mb-2 ms-1 me-1 fs-sm fw-600" data-animate="fade-up" data-delay="${index * 50}">
            ${item}
        </span>
    `).join('');
  container.innerHTML = html;
}

function renderProjectImages(container, images) {
  if (images.length < 4) return;

  const col1Images = images.slice(0, 2);
  const col2Images = images.slice(2, 4);

  const renderImg = (img, mb) => `
        <img
          src="${urlFor(img).url()}"
          alt="..."
          class="img-fluid ${mb ? 'mb-4' : ''} rounded shadow-light-lg lift"
        />
    `;

  const html = `
      <div class="col-6 mt-8 me-n5" data-animate="fade-up">
        ${renderImg(col1Images[0], true)}
        ${renderImg(col1Images[1], false)}
      </div>
      <div class="col-6" data-animate="fade-up" data-delay="100">
        ${renderImg(col2Images[0], true)}
        ${renderImg(col2Images[1], false)}
      </div>
    `;

  container.innerHTML = html;
}
